module.exports = __webpack_public_path__ + "static/media/akkurat-mono-webfont.1da8d821.woff2";